import { type ElementRef, forwardRef } from 'react';
import TextareaAutosizeComponent, {
  type TextareaAutosizeProps as TextareaAutosizeComponentProps,
} from 'react-textarea-autosize';

import { cn } from '@air/utils-tailwind';

import { TEXTAREA_SIZE_CLASSES, type TextareaSize, textarea } from './constants';

export type TextareaAutosizeProps = TextareaAutosizeComponentProps & {
  size?: TextareaSize;
};

export const TextareaAutosize = forwardRef<ElementRef<typeof TextareaAutosizeComponent>, TextareaAutosizeProps>(
  ({ className, size = 'medium', ...restOfProps }, forwardedRef) => {
    return (
      <TextareaAutosizeComponent
        className={textarea({ className: cn(TEXTAREA_SIZE_CLASSES[size], className) })}
        ref={forwardedRef}
        {...restOfProps}
      />
    );
  },
);

TextareaAutosize.displayName = 'TextareaAutosize';
